/**
 * @file
 * @author tanghao
 * @date 2019-06-19
 */

import Vue from 'vue';
import Vuex from 'vuex';
import app from './module/app';
import pages from './module/pages';
import api from './../api'
//引入
import dynamic from '@wd/lowcode-h5/plugin/store/index.js';
Vue.use(Vuex);

const store = new Vuex.Store({
    state: {
        tabbar: {
            show: true,
            active: 'home',
        },
        pageConfigs: [],
        facecount:0,
        findBindInfo: null,
        distributionId: null,
        idcardBefore: null,
        userInfo: localStorage.getItem('WDuserInfo') && localStorage.getItem('WDuserInfo') != 'undefined'? JSON.parse(localStorage.getItem('WDuserInfo')) : {},
        surpluscount:4,
        isOpen:false,
        homepage:[],
        menuList:[],
        isNewSaas:false//用户中心改造标识
    },
    mutations: {
        setSaasFlag(state, val){
            state.isNewSaas = val
        },
        setUserInfo(state, payload) {
            state.userInfo = {...state.userInfo,...payload};
            localStorage.setItem('WDuserInfo',JSON.stringify(state.userInfo))
        },
        setTabbar(state, payload) {
            state.tabbar = { ...state.tabbar, ...payload };
          },
        setPageConfigs(state, payload) {
            state.pageConfigs = payload;
        },
        postAccountLoginByAuthCode (state, data) {
            api.usercenter.postAccountLoginByAuthCode({ data }).then(res => {
                state.userInfo = res
            })
        },
        setIsOpen(state, payload) {
            state.isOpen = payload;
        },
        homepage(state,homepage){
            state.homepage = homepage;
        },
        menuList(state,menuList){
            state.menuList = menuList;
        }
    },
    actions: {
        //
    },
    getters: {
        userInfo (state) {
            return state.userInfo
        }
    },
    modules: {
        app,
        pages,
        dynamic
    },
});

export default store
